(ns frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.portfolio-information
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]))

(defn portfolio-summary-table
  [data]
  (let [remove-page? (empty-table-data? (:portfolio-information data) :portfolio-summary)]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Portfolio summary"
                                   :toc-item   true})
       (horizontal-table-pdf/table (->> data
                                        :portfolio-information
                                        :portfolio-summary))
       (text-content/optional-footer (->> data
                                          :portfolio-information
                                          :portfolio-summary))))))
(defn portfolio-information-page
  [data]
  (portfolio-summary-table data))
